module.exports = __webpack_public_path__ + "img/under-video.79fe08c5.svg";